"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentCalc = void 0;
const constants_1 = require("../constants");
const ethers_1 = require("ethers");
class PaymentCalc {
    static async calculatePayment(axiomV2Query, options) {
        // Get proofVerificationGas from contract
        let proofVerificationGas = await axiomV2Query.proofVerificationGas(); // in gas units
        if (proofVerificationGas === 0n) {
            proofVerificationGas = constants_1.ConstantsV2.FallbackProofVerificationGas;
        }
        proofVerificationGas = proofVerificationGas.toString();
        // Get axiomQueryFee from contract
        let axiomQueryFee = await axiomV2Query.axiomQueryFee(); // in wei
        if (axiomQueryFee === 0n) {
            axiomQueryFee = constants_1.ConstantsV2.FallbackAxiomQueryFeeWei;
        }
        const axiomQueryFeeWei = ethers_1.ethers.parseUnits(axiomQueryFee.toString(), "wei");
        // Convert callback gas limit to wei
        const callbackGasLimit = (options.callbackGasLimit ?? constants_1.ConstantsV2.DefaultCallbackGasLimit).toString();
        // payment = maxFeePerGas * (proofVerificationGas + callbackGasLimit) + axiomQueryFee
        const payment = BigInt(options.maxFeePerGas ?? constants_1.ConstantsV2.DefaultMaxFeePerGasWei) *
            (BigInt(proofVerificationGas) + BigInt(callbackGasLimit)) +
            BigInt(axiomQueryFeeWei);
        return payment.toString();
    }
    static async getBalance(providerUri, userAddress, axiomQueryAddress, axiomQueryAbi) {
        const provider = new ethers_1.ethers.JsonRpcProvider(providerUri);
        const contract = new ethers_1.ethers.Contract(axiomQueryAddress, axiomQueryAbi, provider);
        return await contract.balances(userAddress);
    }
}
exports.PaymentCalc = PaymentCalc;
//# sourceMappingURL=paymentCalc.js.map